import React from 'react';
import axios from 'axios';
import { Button, Form, Input, Checkbox } from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

class EditCourse extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            code: this.props.course.code,
            ects: this.props.course.ects,
            lectureNumber: this.props.course.lectureNumber,
            exerciseNumber: this.props.course.exerciseNumber,
            seminarNumber: this.props.course.seminarNumber,
            tutorialNumber: this.props.course.tutorialNumber,
            mandatory: this.props.course.mandatory,
            fromOtherStudyProgram: this.props.course.fromOtherStudyProgram,
            prerequisiteCourse: this.props.course.prerequisiteCourse,

            ectsErr: false,
            codeErr: false,
            lectureNumberErr: false,
            exerciseNumberErr: false,

        };
        this.addCourse = this.addCourse.bind(this);
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps !== this.props) {
            this.setState({
                code: this.props.course.code,
                ects: this.props.course.ects,
                lectureNumber: this.props.course.lectureNumber,
                exerciseNumber: this.props.course.exerciseNumber,
                seminarNumber: this.props.course.seminarNumber,
                mandatory: this.props.course.mandatory,
                fromOtherStudyProgram: this.props.course.fromOtherStudyProgram,
                prerequisiteCourse: this.props.course.prerequisiteCourse
            });
        }
    }

    addCourse(
        code,
        ects,
        lectureNumber,
        exerciseNumber,
        seminarNumber,
        tutorialNumber,
        mandatory,
        fromOtherStudyProgram,
        prerequisiteCourse
    ) {
        let optLock = this.props.course.optLock;
        let id = this.props.course.id;

        let createSemObj = {
            code,
            optLock,
            id,
            ects,
            lectureNumber,
            exerciseNumber,
            seminarNumber,
            tutorialNumber,
            mandatory,
            fromOtherStudyProgram,
            prerequisiteCourse
        };

        console.log('mandatory', mandatory);
        console.log('fromOtherStudyProgram', fromOtherStudyProgram);

        axios.put('study-programs/semesters/edit-course/', { ...createSemObj })
            .then(res => {
                toast('Izmjena predmeta je uspješno izvršena.');
                this.props.getCoursesForSemester();
                this.props.closeEditMode();
            })
            .catch(err => {
                toast('Došlo je do greške! Izmjena predmeta nije uspjela.');
            });
    }

    render() {
        return (
            <div>
                <h3>Izmjena predmeta: {this.props.course.courseBasic.name}</h3>
                <Form noValidate>
                    <Form.Group widths="equal">
                        <Form.Field
                            required
                            error={this.state.codeErr}
                            control={Input}
                            label="Šifra"
                            value={this.state.code}
                            onChange={(e) => this.setState({ code: e.target.value })}
                            name="code"
                            placeholder="Unesite šifru"
                        />
                        <Form.Field
                            required
                            error={this.state.ectsErr}
                            control={Input}
                            label="Broj ECTS bodova"
                            type="number"
                            value={this.state.ects}
                            onChange={(e) => this.setState({ ects: e.target.value })}
                            name="ects"
                            placeholder="Unesite broj ects bodova"
                        />
                        <Form.Field />
                    </Form.Group>
                    <Form.Group widths="equal">
                        <Form.Field
                            required
                            error={this.state.lectureNumberErr}
                            control={Input}
                            label="Predavanja (sati)"
                            type="number"
                            value={this.state.lectureNumber}
                            onChange={(e) => this.setState({ lectureNumber: e.target.value })}
                            name="lectureNumber"
                            placeholder="Unesite broj predavanja"
                        />
                        <Form.Field
                            required
                            error={this.state.exerciseNumberErr}
                            control={Input}
                            label="Vježbe (sati)"
                            type="number"
                            value={this.state.exerciseNumber}
                            onChange={(e) => this.setState({ exerciseNumber: e.target.value })}
                            name="exerciseNumber"
                            placeholder="Unesite broj vježbi"
                        />
                        <Form.Field
                            control={Input}
                            label="Seminari"
                            type="number"
                            value={this.state.seminarNumber}
                            onChange={(e) => this.setState({ seminarNumber: e.target.value })}
                            name="seminarNumber"
                            placeholder="Unesite seminare"
                        />
                        <Form.Field
                            control={Input}
                            label="Tutorijali (sati)"
                            type="number"
                            value={this.state.tutorialNumber}
                            onChange={(e) => this.setState({ tutorialNumber: e.target.value })}
                            name="tutorialNumber"
                            placeholder="Unesite broj tutorijala"
                        />
                    </Form.Group>
                    <Form.Group>
                        <Form.Field>
                            <label>Je li predmet izborni?</label>
                            <Checkbox
                                disabled={this.state.fromOtherStudyProgram}
                                checked={!this.state.mandatory}
                                label=""
                                value={this.state.mandatory}
                                onChange={(e) => this.setState({ mandatory: !this.state.mandatory })}
                            />
                        </Form.Field>
                        <Form.Field>
                            <label>Je li predmet uslovni?</label>
                            <Checkbox
                                disabled={this.state.fromOtherStudyProgram}
                                label=""
                                value={this.state.prerequisiteCourse}
                                checked={this.state.prerequisiteCourse}
                                onChange={(e) => this.setState({ prerequisiteCourse: !this.state.prerequisiteCourse, fromOtherStudyProgram: false })}
                            />
                        </Form.Field>
                        <Form.Field width={6}>
                            <label>Je li predmet sa drugog studijskog programa ili NPP-a?</label>
                            <Checkbox
                                disabled={this.state.prerequisiteCourse}
                                label=""
                                checked={this.state.fromOtherStudyProgram}
                                value={this.state.fromOtherStudyProgram}
                                onChange={(e) => this.setState({ fromOtherStudyProgram: !this.state.fromOtherStudyProgram, mandatory: false })}
                            />
                        </Form.Field>
                    </Form.Group>
                    {/* <Form.Field> */}
                    {/*    <label>  Je li predmet izborni?</label> */}
                    {/*    <Checkbox */}
                    {/*        label="" */}
                    {/*        checked={!this.state.mandatory} */}
                    {/*        value={this.state.mandatory} */}
                    {/*        onChange={(e) => this.setState({ mandatory: !this.state.mandatory })} */}
                    {/*    /> */}
                    {/* </Form.Field> */}
                    <Button
                        color="blue"
                        size="small"
                        onClick={() => this.addCourse(
                            this.state.code,
                            this.state.ects,
                            this.state.lectureNumber,
                            this.state.exerciseNumber,
                            this.state.seminarNumber ? this.state.seminarNumber : 0,
                            this.state.tutorialNumber ? this.state.tutorialNumber : 0,
                            this.state.mandatory,
                            this.state.fromOtherStudyProgram,
                            this.state.prerequisiteCourse
                        )}

                    >  Sačuvaj izmjene
                    </Button>
                    <Button
                        color="blue"
                        size="small"
                        basic="true"
                        onClick={this.props.closeEditMode}
                    >  Odustani
                    </Button>
                </Form>
                <ToastContainer hideProgressBar />
                <br />
            </div>
        );
    }
}

export default EditCourse;



// WEBPACK FOOTER //
// ./src/views/Admin/CreateStudyProgramImplementation/EditCourse.js